import httpRequest from '../../utils/httpRequest'

export const SET_TICKER_LOT_SIZE = 'SET_TICKER_LOT_SIZE'

export const SET_SYMBOL_TICKERS = 'SET_SYMBOL_TICKERS'

export const setTickerLotSize = data => dispatch => dispatch({ type: SET_TICKER_LOT_SIZE, data })

export const setSymbolTickers = data => dispatch => dispatch({ type: SET_SYMBOL_TICKERS, data })

export const getSymbolTickers = () => async dispatch => {
  try {
    const symbolTickers = await httpRequest.get24HrTicker()
    dispatch(setSymbolTickers({ symbolTickers, from: 'rest' }))
  } catch (err) {
    console.log(`status:${err.status} message: ${err.statusText}`)
  }
}
